import React, { Component } from 'react';
import {auth} from '../../../../Config/Firebase'
import {Link} from 'react-router-dom'
import PasswordReset from '../../../Images/PasswordReset.png'
import HavenLogo from '../../../Images/MyHavenLogo.png'
     // Get the action to complete.
 
     // Get the one-time code from the query parameter.
     let actionCode;

    let newPassword;
    let passQuery;
class ResetPassword extends Component {
    state = {
        email: '',
        password: '',
        showPage: false,
        actionCode: '',
        reset: false,
        updatePasswordText: 'Update Your Password'
    }

componentWillMount(){
    passQuery = window.location.search.split('mode=')[1].split('&');

    var actionCode = passQuery[1].split('oobCode=')[1];


    this.setState({
        actionCode : actionCode
    })
    

}

handleResetPassword =(event) =>{
    event.preventDefault()

   
    newPassword = this.state.password
   
    // Verify the password reset code is valid.
    //i had to create a state for the auth, it would show up as undefined 
    auth.verifyPasswordResetCode(this.state.actionCode).then(() => {
  
        console.log(this.state.actionCode);
      auth.confirmPasswordReset(this.state.actionCode, newPassword).then(() =>{
          
        // Password reset has been confirmed and new password updated.
        // TODO: Display a link back to the app, or sign-in the user directly
        // if the page belongs to the same domain as the app:
        // auth.signInWithEmailAndPassword(accountEmail, newPassword);
        this.setState({
            reset: true
        })
        // TODO: If a continue URL is available, display a button which on
        // click redirects the user back to the app via continueUrl with
        // additional state determined from that URL's parameters.
      }).catch((error) =>{
          console.log(error.code, error.message)
        // Error occurred during confirmation. The code might have expired or the
        // password is too weak.
        this.setState({
            updatePasswordText: 'Your Password must be atleast 6 characters.'
        })
      });
    }).catch((error) =>{
        console.log(error.code, error.message)
      // Invalid or expired action code. Ask user to try to reset the password
      // again.
      if(error.code === 'auth/invalid-action-code'){
          this.setState({
              updatePasswordText: 'The email link has expired, you must resend the password reset email.'
          })
      }
    });
   
  }
    
    render() { 
        return (   
        <div>
            {
                this.state.reset === false 
                
                ?  <div className="page">
                        <div className="container-fluid login-form-div">
                            <div className="row">
                                <div className="col-xl-6 leftSideLogin">
                                    <form className="login-form"onSubmit={(event) => {this.handleResetPassword(event)}}>
                                        <li>
                                            <img id="haven-logo" src={HavenLogo} alt=""/>
                                        </li>
                                        <li>    
                                            <label>{this.state.updatePasswordText}</label>
                                        </li>
                                        <li>
                                            <label  id="email-label">EMAIL</label>
                                        </li>
                                        <li>                                
                                            <input type="email" id="emailInput" placeholder="Enter Email"  onChange={(event) => this.setState({ email: event.target.value})}/>
                                        </li>
                                        <li>
                                            <label  id="password-label">NEW PASSWORD</label>
                                        </li>          
                                        <li>
                                            <input type="password" id="passwordInput" placeholder="New Password"  onChange={(event) => this.setState({ password: event.target.value})}/>
                                        </li>
                                        <li>
                                            <button type="submit"className="btn btn-primary large">Update Password</button>
                                        </li>
                                        <li id="bottom-nav"><Link to="/">Back to Login</Link></li>
                                    </form>
                                </div>
                                <div className="d-none d-lg-block col-xl-6 rightSideLogin">
                            <div className="rightPanelDiv">
                                    <img src={PasswordReset} alt="Image of MyHaven" width="400px"/>
                                </div>
                            </div>
                            </div>
                        </div>
                </div> 
            : 
                <div className="page">
                    <div className="container login-form-div">
                        <div className="row">
                            <div className="col-xl-6 leftSideLogin">
                                <form className="login-form"onSubmit={(event) => {this.handleResetPassword(event)}}>
                                <li>
                                    <i style={{fontSize: "60px", color: "#6bb562"}} className="fas fa-check-circle"></i>
                                        <label>Your password has been reset.</label>
                                    </li>                          
                                    <li>
                                        <button type="button"className="btn btn-primary large" onClick><Link to="/" id="resetSuccessfulBackToLogin">Back to Login</Link></button>
                                    </li>                   
                                </form>                   
                            </div>
                            <div className="d-none d-lg-block col-xl-6 rightSideLogin">
                            <div className="rightPanelDiv">
                                    <img src={PasswordReset} alt="Image of MyHaven" width="400px"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> 

            }
        </div>
          
         )
    }
}
 
export default ResetPassword;


// WEBPACK FOOTER //
// ./src/Components/Pages/MyHaven/LoginPage/ResetPassword.jsx